import React from 'react';
import { Icon } from '@iconify/react';
import playIcon from '@iconify-icons/lucide/play';
import refreshIcon from '@iconify-icons/lucide/refresh-ccw';

/**
 * P01 · "Continúa aprendiendo" (mockup varA, líneas 790-808).
 * Hero navy con textura que muestra dónde retomar; badge con timestamp
 * (`resumeAt`), nombre del curso, título de la lección grande, barra de
 * progreso cian, meta y CTA "Retomar". Se pinta fuera del padding (usa
 * `margin: 0 -16px`) para que ocupe todo el ancho en móvil.
 */
export default function HomeContinue({
  courseName,
  lessonName,
  progressPct = 0,
  remainLabel,
  resumeAt,
  ctaLabel = 'Retomar',
  onOpen,
  thumbnail,
}) {
  const clamped = Math.max(0, Math.min(100, progressPct));

  return (
    <div
      style={{
        position: 'relative',
        margin: '0 -16px 32px',
        minHeight: 440,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        overflow: 'hidden',
        background: thumbnail
          ? undefined
          : 'repeating-linear-gradient(118deg, #26364F, #26364F 15px, #2E4059 15px, #2E4059 30px)',
      }}
      data-slot="home-continue"
    >
      {thumbnail && (
        <img
          src={thumbnail}
          alt=""
          style={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
      )}
      {resumeAt && (
        <span
          style={{
            position: 'absolute',
            top: 18,
            left: 16,
            display: 'inline-flex',
            alignItems: 'center',
            gap: 7,
            background: 'var(--color-ink)',
            color: '#8FD9EE',
            borderRadius: 999,
            padding: '7px 12px',
            fontSize: 12,
            fontWeight: 800,
          }}
        >
          <Icon icon={refreshIcon} width={14} height={14} aria-hidden="true" />
          {resumeAt}
        </span>
      )}
      <div
        style={{
          position: 'relative',
          padding: '110px 16px 20px',
          background:
            'linear-gradient(to top, rgba(11,20,36,.97) 0%, rgba(11,20,36,.93) 44%, rgba(11,20,36,.62) 74%, rgba(11,20,36,0) 100%)',
        }}
      >
        {courseName && (
          <div
            style={{
              fontSize: 13.5,
              fontWeight: 800,
              color: '#8FD9EE',
              letterSpacing: '.02em',
              marginBottom: 6,
            }}
          >
            {courseName}
          </div>
        )}
        <div
          style={{
            fontSize: 30,
            fontWeight: 800,
            lineHeight: 1.12,
            letterSpacing: '-.025em',
            color: '#fff',
            marginBottom: 18,
            maxWidth: '20ch',
          }}
        >
          {lessonName}
        </div>
        <div
          role="progressbar"
          aria-valuenow={clamped}
          aria-valuemin={0}
          aria-valuemax={100}
          style={{
            height: 3,
            borderRadius: 999,
            background: 'rgba(255,255,255,.3)',
            overflow: 'hidden',
            marginBottom: 7,
            maxWidth: 240,
          }}
        >
          <div
            style={{
              height: '100%',
              borderRadius: 999,
              background: 'var(--color-secondary)',
              width: `${clamped}%`,
            }}
          />
        </div>
        <div
          style={{
            fontSize: 12.5,
            fontWeight: 600,
            color: '#CBD7E8',
            marginBottom: 18,
          }}
        >
          {clamped}% del curso{remainLabel ? ` · ${remainLabel} restantes` : ''}
        </div>
        <button
          type="button"
          onClick={onOpen}
          className="flex items-center justify-center cursor-pointer"
          style={{
            gap: 10,
            width: '100%',
            minHeight: 58,
            border: 0,
            borderRadius: 13,
            background: 'var(--color-accent)',
            color: 'var(--color-ink)',
            fontSize: 17,
            fontWeight: 800,
          }}
        >
          <Icon icon={playIcon} width={20} height={20} aria-hidden="true" />
          {ctaLabel}
        </button>
      </div>
    </div>
  );
}
